export const dataNormatividad = [
  {
    id: 1,
    nameDoc:
      "Lineamientos para el uso del correo electrónico institucional del Instituto Tlaxcalteca De Elecciones.",
    post: "",
    lastUpdate: "",
    pdf: "https://itetlax.org.mx/assets/pdf/archivistico/Lineamientos.pdf",
    pdfMobile: "",
    word: "",
    excel: "",
  },
];

export const dataPlaneacion = [
  {
    id: 1,
    nameDoc: "Programa Anual de Desarrollo Archivístico 2022",
    pdf: "2",
  },
  {
    id: 2,
    nameDoc: "Programa Anual de Desarrollo Archivístico 2023",
    word: "3",
  },
  {
    id: 3,
    nameDoc:
      "Informe Anual de Cumplimiento del Programa de Desarrollo Archivístico",
    pdf: "4",
  },
  {
    id: 4,
    nameDoc: "Integración de Sistema Institucional de Archivo",
    pdf: "11",
  },
  {
    id: 5,
    nameDoc: "Sistema Institucional de Archivos (SIA)",
    pdf: "11",
  },
  {
    id: 6,
    nameDoc: "Programa Anual de Desarrollo Archivístico 2024",
    word: "9",
  },
  {
    id: 7,
    nameDoc:
      "Informe Anual de cumplimiento del Programa de Desarrollo Archivístico 2023",
    word: "10",
  },
  {
    id: 8,
    nameDoc:
      "Programa Anual de Desarrollo Archivístico 2025 ",
      pdf: "18",
  },
  {
    id: 9,
    nameDoc:
      "Informe Anual de Cumplimiento del Programa Anual de Desarrollo Archivístico 2024",
      pdf: "19",
  },
  {
    id: 10,
    nameDoc:
      "PROGRAMA ANUAL DESARROLLO ARCHIVISTICO 2026",
      pdf: "20",
  },
  {
    id: 11,
    nameDoc:
      "INFORME DE CUMPLIMIENTO AL PADA 2025",
      pdf: "21",
  },
];
export const dataInstrumentos = [
  {
    id: 1,
    nameDoc: "Cuadro General de Clasificación Archivística",
    post: "06/11/2023",
    lastUpdate: "",
    pdf: "1",
    excel: "",
  },
  {
    id: 2,
    nameDoc: "Catálogo de Disposición Documental",
    post: "06/11/2023",
    lastUpdate: "",
    pdf: "8",
    excel: "",
  },
  
  {
    id: 3,
    nameDoc: "Ficha Técnica De Valoración Documental",
    post: "03/03/2023",
    lastUpdate: "",
    pdf: "5",
    excel: "",
  },
  {
    id: 4,
    nameDoc: "Cuadro General de Clasificacion ITE 2025",
    post: "14/04/2025",
    lastUpdate: "",
    pdf: "6",
    excel: "",
  },
  {
    id: 5,
    nameDoc: "Cuadro De Clasificación de Series Sustantivas ATTAI",
    post: "14/04/2025",
    lastUpdate: "",
    pdf: "7",
    excel: "",
  },
  {
    id: 6,
    nameDoc: "Cuadro De Clasificación de Series Sustantivas ATCC",
    post: "14/04/2025",
    lastUpdate: "",
    pdf: "88",
    excel: "",
  },
  {
    id: 7,
    nameDoc: "Cuadro De Clasificación de Series Sustantivas ATCSyP",
    post: "14/04/2025",
    lastUpdate: "",
    pdf: "9",
    excel: "",
  },
  {
    id: 8,
    nameDoc: "Cuadro De Clasificación de Series Sustantivas ATI",
    post: "14/04/2025",
    lastUpdate: "",
    pdf: "10",
    excel: "",
  },
  {
    id: 9,
    nameDoc: "Cuadro De Clasificación de Series Sustantivas Consejerías Electorales",
    post: "14/04/2025",
    lastUpdate: "",
    pdf: "11",
    excel: "",
  },
  {
    id: 10,
    nameDoc: "Cuadro De Clasificación de Series Sustantivas DAJ",
    post: "14/04/2025",
    lastUpdate: "",
    pdf: "12",
    excel: "",
  },
  {
    id: 11,
    nameDoc: "Cuadro De Clasificación de Series Sustantivas DOECyEC",
    post: "14/04/2025",
    lastUpdate: "",
    pdf: "13",
    excel: "",
  },
  {
    id: 12,
    nameDoc: "Cuadro De Clasificación de Series Sustantivas DPAyF",
    post: "14/04/2025",
    lastUpdate: "",
    pdf: "14",
    excel: "",
  },
  
  {
    id: 13,
    nameDoc: "Cuadro De Clasificación de Series Sustantivas Presidencia",
    post: "14/04/2025",
    lastUpdate: "",
    pdf: "15",
    excel: "",
  },
    
  {
    id: 14,
    nameDoc: "Cuadro De Clasificación de Series Sustantivas Secretaría Ejecutiva",
    post: "14/04/2025",
    lastUpdate: "",
    pdf: "16",
    excel: "",
  },
  {
    id: 15,
    nameDoc: "Cuadro De Clasificación de Series Sustantivas UTCE",
    post: "14/04/2025",
    lastUpdate: "",
    pdf: "17",
    excel: "",
  },
];
